class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.header = document.querySelector('.header-wrapper');
    if (this.header) this.header.preventHide = false;

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink)
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (this.header) this.header.preventHide = true;
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {this.classList.add('animate', 'active')});

    this.addEventListener('transitionend', () => {
      const containerToTrapFocusOn = this.classList.contains('is-empty') ? this.querySelector('.drawer__inner-empty') : document.getElementById('CartDrawer');
      const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
      trapFocus(containerToTrapFocusOn, focusElement);
    }, { once: true });

    document.body.classList.add('overflow-hidden-drawer');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden-drawer');
    if (this.header) this.header.preventHide = false;
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if(cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') && this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section => {
      const sectionElement = section.selector ? document.querySelector(section.selector) : document.getElementById(section.id);
      sectionElement.innerHTML =
          this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    }));

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer'
      },
      {
        id: 'cart-icon-bubble'
      }
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner'
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      }
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);

// FREE PRODUCT LOGIC

(function () {
  const drawers = Array.from(document.querySelectorAll('cart-drawer'));
  if (!drawers.length) return;

  drawers.forEach((drawer) => {
    drawer.addEventListener('click', async (event) => {
      const target = event.target;

      const optionTile = target.closest('.free-option-value');
      if (optionTile && drawer.contains(optionTile)) {
        const optionContainer = optionTile.closest('.product-option__values');
        if (!optionContainer) return;

        optionContainer.querySelectorAll('.free-option-value').forEach(el => el.classList.remove('active'));
        optionTile.classList.add('active');
        return;
      }

      const addBtn = target.closest('.add-free-product-button');
      if (!addBtn || !drawer.contains(addBtn)) return;

      if (addBtn.disabled || addBtn.getAttribute('aria-disabled') === 'true') return;

      const wrapper = addBtn.closest('.cart-item--free');
      if (!wrapper) return;

      addBtn.classList.add('loading');
      addBtn.setAttribute('aria-disabled', 'true');

      let selectedVariantId = null;
      const optionGroups = wrapper.querySelectorAll('.product-option__values');

      if (optionGroups.length) {
        let resultVariantIds = null;

        optionGroups.forEach(group => {
          const activeOption = group.querySelector('.free-option-value.active');
          if (!activeOption) return;

          const ids = (activeOption.dataset.variantIds || '').split(',').filter(Boolean);

          if (resultVariantIds === null) {
            resultVariantIds = ids;
          } else {
            resultVariantIds = resultVariantIds.filter(id => ids.includes(id));
          }
        });

        if (resultVariantIds && resultVariantIds.length === 1) {
          selectedVariantId = resultVariantIds[0];
        }
      }

      if (!selectedVariantId) {
        selectedVariantId = wrapper.dataset.defaultVariant;
      }

      try {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            id: Number(selectedVariantId),
            quantity: 1
          })
        });

        if (!response.ok) throw new Error('Failed to add free product.');

        const cartDrawerEl = document.querySelector('cart-drawer');
        if (cartDrawerEl && typeof cartDrawerEl.renderContents === 'function') {
          const cartState = await fetch('/?sections=cart-drawer,cart-icon-bubble').then(r => r.json());

          cartDrawerEl.renderContents({
            sections: cartState,
            id: selectedVariantId
          });
          requestAnimationFrame(() => {
            requestAnimationFrame(() => {
              initUpsellSwiper();
            });
          });
        }
      } catch (err) {
        console.error(err);
      } finally {
        addBtn.classList.remove('loading');
        addBtn.removeAttribute('aria-disabled');
      }
    });

    drawer.addEventListener('keydown', (event) => {
      const el = event.target;
      if (!el || !el.classList) return;
      if (!el.classList.contains('free-option-value')) return;

      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        const optionContainer = el.closest('.product-option__values');
        if (!optionContainer) return;
        optionContainer.querySelectorAll('.free-option-value').forEach(sib => sib.classList.remove('active'));
        el.classList.add('active');
      }
    });
  });
})();